import { render, staticRenderFns } from "./StoresItem.vue?vue&type=template&id=43af76a2&scoped=true&"
import script from "./StoresItem.vue?vue&type=script&lang=js&"
export * from "./StoresItem.vue?vue&type=script&lang=js&"
import style0 from "./StoresItem.vue?vue&type=style&index=0&id=43af76a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af76a2",
  null
  
)

export default component.exports